import "../css/Socials.css";

export default function Socials() {
  const socials = [
    {
      name: "LinkedIn",
      href: "https://www.linkedin.com/company/floteco2/",
      iconClass: "fab fa-linkedin",
    },
    {
      name: "YouTube",
      href: "https://www.youtube.com/channel/UCMV3H97FoAE9DSyG100-Xcg",
      iconClass: "fab fa-youtube",
    },
  ];

  return (
    <div className="footer-socials">
      {socials.map(({ name, href, iconClass }) => (
        <a
          key={name}
          href={href}
          aria-label={name}
          title={name}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i aria-hidden="true" className={iconClass}></i>
        </a>
      ))}
    </div>
  );
}
